import { useCallback } from "react";
import { ActionHookContext } from "./types";

export function useFormActions(context: ActionHookContext) {
  const { store } = context;

  // Using store methods directly - store is stable from zustand
  const updateFormData = useCallback(
    (data: Parameters<typeof store.updateFormData>[0]) => {
      store.updateFormData(data);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const resetForm = useCallback(() => {
    store.resetForm();
  }, [store]);

  const setValidationError = useCallback(
    (show: boolean) => {
      store.setValidationError(show);
    },
    [store]
  );

  const setUploadedFrontImage = useCallback(
    (file: File | null) => {
      store.setUploadedFrontImages(file ? [file] : []);
    },
    [store]
  );

  const setUploadedBackImage = useCallback(
    (file: File | null) => {
      store.setUploadedBackImages(file ? [file] : []);
    },
    [store]
  );

  const clearUploadedImages = useCallback(() => {
    store.clearUploadedImages();
  }, [store]);

  return {
    updateFormData,
    resetForm,
    setValidationError,
    setUploadedFrontImage,
    setUploadedBackImage,
    clearUploadedImages,
  };
}
